import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Country } from '~/Api/Country';
import {
	RegionAvailability,
	selectRegionAvailabilities,
	State as RegionState,
} from '~/MedicinalBrandsAnalytics/Region';

import AvailabilityTab from './AvailabilityTab';

import type { VirtualBrandState } from '../reducer';
import { AnalyticDataSources, VirtualBrandAnalytics } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';
import {
	selecAnalyticaltDataSourceCountries,
	selectAnalyticalDataSourcesByCountry,
} from '~/MedicinalBrandsAnalytics/DataSource/reducer';
import { State as DataSourceState } from '~/MedicinalBrandsAnalytics/DataSource';

interface State {
	medicinalBrandsAnalyticsVirtualBrand: VirtualBrandState;
	medicinalBrandsAnalyticsRegion: RegionState;
	medicinalBrandsAnalyticsDataSource: DataSourceState;
}

type OwnProps = {
	virtualBrand: VirtualBrand;
};

const getAnalyticsDataSources = (analticVirtualPacks: VirtualBrandAnalytics['virtualPacks'] | null) => {
	if (!analticVirtualPacks) {
		return [];
	}

	return analticVirtualPacks.reduce((aggregator: AnalyticDataSources, virtualpack) => {
		return aggregator.concat(virtualpack.dataSources);
	}, []);
};

const memoizedSelectDataSourceCountries = memoizeOne(selecAnalyticaltDataSourceCountries);

export const memoizedGetDataSources = memoizeOne(getAnalyticsDataSources);

const memoizedSelectDefaultRegionAvailability = memoizeOne(
	(regionState: RegionState, analyticalDataSrouces: AnalyticDataSources): RegionAvailability | null => {
		const availabilities = selectRegionAvailabilities(
			regionState,
			selectAnalyticalDataSourcesByCountry(analyticalDataSrouces)
		);
		return availabilities?.find((regionAvailability) => regionAvailability.region.id === 'europe') || null;
	}
);

function mapStateToProps(
	{ medicinalBrandsAnalyticsRegion, medicinalBrandsAnalyticsVirtualBrand, medicinalBrandsAnalyticsDataSource }: State,
	props: OwnProps
): {
	countries: Country[];
	allDatasourceCountries: Country[];
	defaultRegionAvailability: RegionAvailability | null;
} {
	const analyticVirtualBrandData =
		medicinalBrandsAnalyticsVirtualBrand.analyticsVirtualBrands?.items?.get(props.virtualBrand.id) || null;
	const dataSources = memoizedGetDataSources(analyticVirtualBrandData?.virtualPacks || null);

	return {
		countries: memoizedSelectDataSourceCountries(dataSources),
		allDatasourceCountries: memoizedSelectDataSourceCountries(medicinalBrandsAnalyticsDataSource?.dataSources ?? []),
		defaultRegionAvailability: memoizedSelectDefaultRegionAvailability(medicinalBrandsAnalyticsRegion, dataSources),
	};
}

export default connect(mapStateToProps)(AvailabilityTab);
